import { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ProdutosPage = lazy(() => import('../pages/produtos/page'));
const ProdutoDetalhesPage = lazy(() => import('../pages/produto-detalhes/page'));
const SobrePage = lazy(() => import('../pages/sobre/page'));
const AfiliadosPage = lazy(() => import('../pages/afiliados/page'));
const EquipaPage = lazy(() => import('../pages/equipa/page'));
const ContactosPage = lazy(() => import('../pages/contactos/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const AreaClientePage = lazy(() => import('../pages/area-cliente/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const AdminEquipaPage = lazy(() => import('../pages/admin/equipa/page'));
const AdminProdutosPage = lazy(() => import('../pages/admin/produtos/page'));
const AdminFinanceiroPage = lazy(() => import('../pages/admin/financeiro/page'));
const AdminConteudoPage = lazy(() => import('../pages/admin/conteudo/page'));
const AdminAprovacoesPage = lazy(() => import('../pages/admin/aprovacoes/page'));
const AdminEquipaSitePage = lazy(() => import('../pages/admin/equipa-site/page'));
const AdminContactosInfoPage = lazy(() => import('../pages/admin/contactos-info/page'));
const AdminFooterConfigPage = lazy(() => import('../pages/admin/footer-config/page'));
const AdminInicioConfigPage = lazy(() => import('../pages/admin/inicio-config/page'));
const AdminProdutosConfigPage = lazy(() => import('../pages/admin/produtos-config/page'));
const AdminSobreConfigPage = lazy(() => import('../pages/admin/sobre-config/page'));
const WhatsAppConfigPage = lazy(() => import('../pages/admin/whatsapp-config/page'));
const AfiliadosConfigPage = lazy(() => import('../pages/admin/afiliados-config/page'));
const EmailConfigPage = lazy(() => import('../pages/admin/email-config/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const LoadingSpinner = () => (
  <div className="min-h-screen bg-black flex items-center justify-center">
    <div className="w-16 h-16 border-4 border-yellow-400 border-t-transparent rounded-full animate-spin"></div>
  </div>
);

const routes: RouteObject[] = [
  {
    path: '/',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <HomePage />
      </Suspense>
    ),
  },
  {
    path: '/produtos',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <ProdutosPage />
      </Suspense>
    ),
  },
  {
    path: '/produto/:id',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <ProdutoDetalhesPage />
      </Suspense>
    ),
  },
  {
    path: '/sobre',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <SobrePage />
      </Suspense>
    ),
  },
  {
    path: '/afiliados',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <AfiliadosPage />
      </Suspense>
    ),
  },
  {
    path: '/equipa',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <EquipaPage />
      </Suspense>
    ),
  },
  {
    path: '/contactos',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <ContactosPage />
      </Suspense>
    ),
  },
  {
    path: '/login',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <LoginPage />
      </Suspense>
    ),
  },
  {
    path: '/area-cliente',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <AreaClientePage />
      </Suspense>
    ),
  },
  {
    path: '/admin',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <AdminPage />
      </Suspense>
    ),
  },
  {
    path: '/admin/equipa',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <AdminEquipaPage />
      </Suspense>
    ),
  },
  {
    path: '/admin/produtos',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <AdminProdutosPage />
      </Suspense>
    ),
  },
  {
    path: '/admin/financeiro',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <AdminFinanceiroPage />
      </Suspense>
    ),
  },
  {
    path: '/admin/conteudo',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <AdminConteudoPage />
      </Suspense>
    ),
  },
  {
    path: '/admin/aprovacoes',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <AdminAprovacoesPage />
      </Suspense>
    ),
  },
  {
    path: '/admin/equipa-site',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <AdminEquipaSitePage />
      </Suspense>
    ),
  },
  {
    path: '/admin/contactos-info',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <AdminContactosInfoPage />
      </Suspense>
    ),
  },
  {
    path: '/admin/footer-config',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <AdminFooterConfigPage />
      </Suspense>
    ),
  },
  {
    path: '/admin/inicio-config',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <AdminInicioConfigPage />
      </Suspense>
    ),
  },
  {
    path: '/admin/produtos-config',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <AdminProdutosConfigPage />
      </Suspense>
    ),
  },
  {
    path: '/admin/sobre-config',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <AdminSobreConfigPage />
      </Suspense>
    ),
  },
  {
    path: '/admin/whatsapp-config',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <WhatsAppConfigPage />
      </Suspense>
    ),
  },
  {
    path: '/admin/afiliados-config',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <AfiliadosConfigPage />
      </Suspense>
    ),
  },
  {
    path: '/admin/email-config',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <EmailConfigPage />
      </Suspense>
    ),
  },
  {
    path: '*',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <NotFoundPage />
      </Suspense>
    ),
  },
];

export default routes;
